export default __webpack_public_path__ + "static/media/laundrypass_promotion.16be5413.png";